/** 条件に当てはまる文字の一覧があれば、ラベルの後ろにコード表記で並べる。 */
export function PasswordRuleLabel({ label, characters }: { label: string; characters?: string }) {
	return (
		<span>
			{label}
			{characters && (
				<>
					:{" "}
					<code className="rounded-2 bg-line-1 px-1 py-0.5 font-mono select-text">
						{characters}
					</code>
				</>
			)}
		</span>
	);
}
